<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>

            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>

                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success" @click="onClickEditParametroVitale(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Elimina" variant="outline-danger" @click="onClickDeleteParametroVitale(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <rsa-configurazione-parametri-vitali-presidio-modal-edit-component ref="cmpRsaConfigurazioneParametriVitaliModalEdit" @onSave="onParametroVitaleSave" @deleteParametroVitale="onParametroVitaleDelete" @onCloseModal="loadParametriVitaliData" />
            <b-row class="sa-label-info">
                <b-col lg="3">
                    <p>Record Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneParametriVitaliPresidioModalEditComponent from "./RsaConfigurazioneParametriVitaliPresidioModalEditComponent.vue";

export default {
    components: { RsaConfigurazioneParametriVitaliPresidioModalEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaparametrivitalipianificazione",
            listKey: 0,
            items: [],
            filtroConfigurazioneParametriVitali: {},
            fields: [
                { key: "index", label: "*" },
                { key: "presidio", label: "Presidio" },
                { key: "frequenza", label: "Frequenza" },
                { key: "ripetizioni", label: "N. Rilevazioni" },
                { key: "diario", label: "Diario" },
                { key: "actions", label: "", class: "sa-table-column-action-double" },
            ],
        };
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadParametriVitaliData();
        },
    },

    methods: {
        loadParametriVitaliData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroConfigurazioneParametriVitali"]) {
                me.filtroConfigurazioneParametriVitali = JSON.parse(sessionStorage["filtroConfigurazioneParametriVitali"]);
            }
            me.filtroConfigurazioneParametriVitali.page = me.currentPage;
            me.filtroConfigurazioneParametriVitali.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroConfigurazioneParametriVitali, me.loadParametriVitaliDataSuccess, me.loadParametriVitaliDataError);
        },
        loadParametriVitaliDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },
        loadParametriVitaliDataError(error) {
            let me = this;
            me.$emit("afterLoadData");
            console.error("Errore durante il caricamento dei dati di loadSpecializzazionePaiDataError:", error);
            me.items = [];
            me.rows = 0;
        },

        onClickEditParametroVitale(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneParametriVitaliModalEdit.setId(item.id);
        },
        onClickNuovoParametroVitale() {
            let me = this;
            // me.$refs.cmpRsaConfigurazioneParametriVitaliModalEdit.show({
            //     id: null,
            //     descrizione: null,
            //     valoreMinimo: null,
            //     valoreMassimo: null,
            //     numeroValori: null,
            //     ausilio: null,
            // });
            me.$refs.cmpRsaConfigurazioneParametriVitaliModalEdit.setId(null);
        },
        onClickDeleteParametroVitale(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneParametriVitaliModalEdit.onDeleteParametroVitale(item);
        },
        onParametroVitaleSave() {
            let me = this;
            me.loadParametriVitaliData();
        },

        onParametroVitaleDelete() {
            let me = this;
            me.loadParametriVitaliData();
        },

        onCloseModalParametroVitale() {
            let me = this;
            me.loadParametriVitaliData();
        },
        onAssociaStruttura(item) {
            let me = this;
            me.$refs.mdlRsaConfigurazioneParametriVitaliAssociaStruttura.init(item.id);
        },
        onAfterSave() {
            let me = this;
            me.loadParametriVitaliData();
        },
    },
};
</script>
